import { useTranslation } from 'next-i18next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import clsx from 'clsx';

import { Container } from '@ui/Container';

import { ArticleCard } from '@components/BlogPage/ArticleCard';
import Header from '@components/layout/Header';
import { Footer } from '@components/layout/Footer';
import SEOHead from '@components/SEOHead';

import { articles } from '@data/articles';

export default function Blog() {
  const { t: tt } = useTranslation('blog');

  return (
    <>
      <SEOHead
        title={tt('seo.title')}
        description={tt('seo.description')}
        type="website"
        keywords={tt('seo.keywords')}
        url="https://www.aigirlfriend.wtf/blog"
        imageUrl="https://www.aigirlfriend.wtf/web-banner-min.jpg"
      />

      <Header />

      <div className="min-h-screen flex flex-col">
        <Container as="main" className={clsx('flex-1', 'pt-[85px]')}>
          <div className="flex flex-col text-center">
            <h1 className="my-0 text-[40px]">{tt('details.header')}</h1>
            <p className="mb-5 mt-1 text-[16px]">{tt('details.subHeader')}</p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 xl:grid-cols-4 gap-10">
            {articles.map((article) => (
              <ArticleCard
                key={article.id}
                title={article.title}
                previewImageUrl={article.imgSrc}
                previewText={article.previewText}
                date={article.date}
                link={article.link}
              />
            ))}
          </div>
        </Container>

        <Footer />
      </div>
    </>
  );
}

export async function getStaticProps({ locale }) {
  return {
    props: {
      ...(await serverSideTranslations(locale, ['header', 'footer', 'blog'])),
    },
  };
}
